module.exports = __webpack_public_path__ + "img/hacienda-resort-4.455f6a0b.jpg";